








































































































import {Vue, Component} from 'vue-property-decorator';
import AnimatedInput from "@/components/AnimatedInput.vue";
import User from "@/models/User";
import SignupAdapter from "@/adapters/signup";
import Address from "@/models/Address";
import { AxiosError } from 'axios';
import countries from "@/util/countries";

const signupAdapter = new SignupAdapter();

@Component({
  components: {AnimatedInput},
})
export default class Enterprise extends Vue {

  consent: boolean = false;
  enterme: string = "";
  user: User = User.createEmpty();
  address: Address = Object.assign(new Address(), { country: 'DE' });
  signupStarted: boolean = false;

  countries = countries;

  startSignup() {
    if (!this.consent) {
      this.$swal('Zustimmung notwendig', 'Bitte akzeptiere die AGB und Datenschutzbedinungen', 'error');
      return;
    }

    const that = this;
    signupAdapter.startSignup(this.user, this.address, 'schicks_digital_enterprise').then((data: User) => {
      that.signupStarted = true;
      that.$nextTick(() => {
        //@ts-ignore
        const novalnet: any = Novalnet;
        novalnet.setParam("nn_it", "inline");
        novalnet.setParam("txn_secret", data.paymentToken);
        novalnet.render('novalnet_payment_form');
      });
    }).catch((error: AxiosError) => {
      if (error.response && error.response.status === 429) {
        this.$swal('Zu viele Anfragen', 'Bitte warte mindestens ' + error.response.data.message + ' Sekunden', 'error');
      } else if (error.response && error.response.status === 409) {
        if (error.response.data.message === 'user invited') {
          this.$swal('Registrierung abschließen', 'Wir haben Dir einen Link an die eingegebene E-Mail Adresse gesendet. Bitte öffne die E-Mail und klicke auf den Link, um die Registrierung abzuschließen.', 'info');
        } else {
          this.$toast.info("Die E-Mail-Adresse ist bereits registriert. Bitte logge Dich ein.");
          this.$router.push('login');
        }
      } else {
        this.$toast.error("Ein Fehler ist aufgetreten. Bitte versuche es später erneut.");
      }
    });
  }
}
